export const getSlides = () => {
  return `
  query {
    slides(stage: PUBLISHED) {
      id
      imageSlide {
        fileName
        url
        width
        size
      }
      publicationEnd
      publicationStart
      show
      subtitle
      title
      fullDescription
    }
  }`;
}
